"use strict";

exports.__esModule = true;
exports.parse = parse;

var _htmlParser = _interopRequireDefault(require("../../utils/html-parser"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Parses a given HTML fragment and returns them as tags.
 *
 * @param {string} html fragment to parse.
 */
function parse(html) {
  if (typeof html !== 'string') {
    return [];
  }

  var tags = [];

  try {
    var currentIndex = 0;
    (0, _htmlParser["default"])(html, {
      start: function start(type, attr) {
        var tag = {
          type: type
        };

        if (attr.length) {
          tag.props = extractProps(attr);
        }

        tags.push(tag);
        currentIndex = tags.length - 1;
      },
      chars: function chars(children) {
        if (tags[currentIndex] && tags[currentIndex].type && children) {
          tags[currentIndex].children = children;
        }
      }
    });
  } catch (e) {}

  return tags;
}

function extractProps(attrs) {
  return (attrs || []).reduce(function (acc, curr) {
    acc[curr.name] = curr.value;
    return acc;
  }, {});
}